import { Typography } from "@material-ui/core";
import { useEffect, useState } from "react";
import { useStyles } from "../dispensacao-cadastro-style";
import { DispensacaoMedicamento } from "../models/dispensacao-models";
import { DispensacaoStepsProp } from "../models/dispensacao-props";
import { DispensacaoMedicamentosCard } from "./dispensacao-medicamentos-card";


export const DispensacaoMedicamentosForm = (({ visualizacao, dispensacao, editarMedicamentos }: DispensacaoStepsProp) => {
  const styles = useStyles();
  const [meds, setMeds] = useState<Array<DispensacaoMedicamento[]>>([]);

  useEffect(() => {
    let codigosDistintos = dispensacao.medicamentos
      ?.map(m => m.codigoAnvisa)
      ?.filter(selecionarUnicos);

    let matrizMedicamentos: Array<DispensacaoMedicamento[]> = [];

    codigosDistintos?.forEach((c) => {
      let medicamentosIguas = dispensacao.medicamentos?.filter(m => m.codigoAnvisa === c);
      matrizMedicamentos[codigosDistintos.indexOf(c)] = medicamentosIguas;
    })

    setMeds(matrizMedicamentos);
  }, [dispensacao.medicamentos]);

  const selecionarUnicos = (value: string, index: number, array: string[]) =>
    array.indexOf(value) === index;

  return (
    <>
      {dispensacao.medicamentos && editarMedicamentos !== undefined &&
        <div className={`flex-column w-100 h-100`}>
          <div className={`flex-column ${styles.titleContainer}`}>
            <Typography className={styles.titleStyle} variant="h6">Medicamentos</Typography>
            <Typography className={styles.titleStyle} variant="subtitle2">Informe os dados dos medicamentos.</Typography>
          </div>

          <div className={`flex-column h-100 ${styles.innerFormContainerMedicamento}`}>
            {
              meds?.map((medicamentos, index) => (
                <div key={index} className={`flex-column w-100 ${styles.cardMedicamentoItem}`}>
                  <DispensacaoMedicamentosCard visualizacao={visualizacao} medicamentos={medicamentos} editar={editarMedicamentos} />
                </div>
              ))
            }
          </div>
        </div>
      }
    </>
  );
});